/* RESPONSIBLE TEAM: team-ai-agent */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { DRAWER_EDITOR_QUERY_PARAMS } from 'embercom/services/knowledge-hub-drawer-editor-service';
import type { EditorMode } from 'embercom/components/knowledge-hub/content-editor/drawer-editor';

export default class ConfigurationAgentController extends Controller {
  queryParams = [...DRAWER_EDITOR_QUERY_PARAMS];

  @tracked activeContentId?: number;
  @tracked activeContentType?: string;
  @tracked editorMode?: EditorMode;
  @tracked collectionId?: string;
  @tracked contentLocale?: string;
  @tracked folderId?: string;
}
